import { renderMarkdown } from '../../lib/markdown'

const BUBBLE =
  'min-w-0 self-start rounded-lg rounded-tl-sm px-2.5 py-1.5 text-xs leading-relaxed text-stone-800 [overflow-wrap:anywhere]'

type Props = {
  text: string
  /** `bubble` is the assistant's own reply; `plain` is reasoning and tool output. */
  variant?: 'plain' | 'bubble'
}

export default function Markdown({ text, variant = 'plain' }: Props) {
  return (
    <div
      className={`markdown ${variant === 'bubble' ? BUBBLE : ''}`}
      dangerouslySetInnerHTML={{ __html: renderMarkdown(text) }}
    />
  )
}
